<!-- <div class="m-t10 flex-row-end"><gp-pvfv-setting></gp-pvfv-setting></div> -->
<div  *ngIf="!isDataAvailable" class="flex-col-center m-t75">       
    <gp-chart-loading-animation></gp-chart-loading-animation>
</div>
<!-- <mat-table [ngStyle]="isAdditionalColumns?'addColTableWidth':''" [dataSource]="dataSource" *ngIf="isDataAvailable" cdkDropList -->
<!-- <mat-table style="width: 120%" [dataSource]="dataSource" *ngIf="isDataAvailable" cdkDropList -->
<mat-table [ngClass]="isAdditionalColumns?'addColTableWidth':''" [dataSource]="dataSource" *ngIf="isDataAvailable" cdkDropList
cdkDropListOrientation="horizontal"
(cdkDropListDropped)="drop($event)"> 
    <ng-container  matColumnDef="yr" [sticky]="true">
        <mat-header-cell class=""  *matHeaderCellDef> 
            <span>YEAR</span>            
        </mat-header-cell>
        <mat-cell class="p-r10" *matCellDef="let element"> 
            <div class="flex-col-container">
                <!-- [ngClass]="(pClRetAge===element.c1Age || sClRetAge===element.c2Age)?'markerBg':''" -->
                <span class="" [ngClass]="((pClRetAge && pClRetAge===element.c1Age) || (sClRetAge && sClRetAge===element.c2Age))?'B blueText20':''" > 
                    {{element.yr}}                     
                </span>
                <!-- <span class="gray-text font12 pointer" [matMenuTriggerFor]="clientMenu" [matMenuTriggerData]="{clientid: pClId}"><span class="m-r3">Client Age:</span> <span class="font14 m-l10">{{element.c1Age}}</span></span>
                <span class="gray-text font12 pointer" *ngIf="element.c2Age" [matMenuTriggerFor]="clientMenu" [matMenuTriggerData]="{clientid: sClId}"><span class="m-r3">Spouse Age:</span> <span class="font14">{{element.c2Age}}</span></span>                 -->
                <!-- <span class="gray-text font14"><span class="B m-r3">Spouse Age:</span> {{element.c1Age}} </span> -->
            </div>
        </mat-cell>
    </ng-container>
    <ng-container  matColumnDef="c1Age" [sticky]="true">
        <mat-header-cell class="th-right" *matHeaderCellDef> 
            <span class="ip-right-align blue-text pointer" [matMenuTriggerFor]="clientMenu" [matMenuTriggerData]="{clientid: pClId}"> CLIENT <br> AGE</span>
        </mat-header-cell>
        <mat-cell class="th-right" *matCellDef="let element"> 
            <div class="flex-col-container">
                <span class="" [ngClass]="(pClRetAge && pClRetAge===element.c1Age)?'B blueText20':''"> {{element.c1Age?element.c1Age:'-'}}</span>                
                
            </div>
        </mat-cell>
    </ng-container>
    <ng-container  matColumnDef="c2Age" [sticky]="true">
        <mat-header-cell class="th-right" *matHeaderCellDef> 
            <span class="ip-right-align blue-text pointer" [matMenuTriggerFor]="clientMenu" [matMenuTriggerData]="{clientid: sClId}"> SPOUSE <br> AGE</span>          
            <!-- <div class="m-r5">                
                <mat-icon *ngIf="!isAdditionalColumns"  class="pointer font40 m-b10" matTooltipPosition ="below" matTooltipClass="tooltip" matTooltip="Expand" aria-hidden="false" (click)="showAdditionalColumns()">keyboard_arrow_right</mat-icon>
                <mat-icon *ngIf="isAdditionalColumns" class="pointer font40  m-b10" matTooltipPosition ="below" matTooltipClass="tooltip" matTooltip="Collapse" aria-hidden="false" (click)="showAdditionalColumns()">keyboard_arrow_left</mat-icon>
            </div> -->
        </mat-header-cell>
        <mat-cell class="th-right" *matCellDef="let element"> 
            <div class="flex-col-container">
                <span class="" [ngClass]="(sClRetAge && sClRetAge===element.c2Age)?'B blueText20':''"> {{element.c2Age?element.c2Age:'-'}} </span>                
            </div>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="portBeginBal">
        <mat-header-cell *matHeaderCellDef class="th-right"> <span class="ip-right-align">MEDIAN PORTFOLIO <br> STARTING  BALANCE</span>  </mat-header-cell>
        <mat-cell class="th-right" *matCellDef="let element" [ngClass]="{'negative': element.portBeginBal<0}">
            {{element.portBeginBal | currency:'USD': 'symbol' : '1.0-0'}} 
        </mat-cell>
    </ng-container> 
    <ng-container matColumnDef="totIncome">
        <mat-header-cell *matHeaderCellDef class="th-right"> INCOME </mat-header-cell>
        <mat-cell class="th-right" *matCellDef="let element" [ngClass]="{'negative': element.totIncome<0}">
            {{element.totIncome | currency:'USD': 'symbol' : '1.0-0'}} 
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="totExpense">
        <mat-header-cell *matHeaderCellDef class="th-right"> EXPENSES </mat-header-cell>
        <mat-cell class="th-right" *matCellDef="let element" [ngClass]="{'negative': element.totExpense<0}">
            {{element.totExpense | currency:'USD': 'symbol' : '1.0-0'}} 
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="totTax">
        <mat-header-cell *matHeaderCellDef class="th-right"> TAXES </mat-header-cell>
        <mat-cell class="th-right" *matCellDef="let element" [ngClass]="{'negative': element.totTax<0}">
            {{element.totTax | currency:'USD': 'symbol' : '1.0-0'}}
        </mat-cell>
    </ng-container>  
    
    <ng-container matColumnDef="totSavings">
        <mat-header-cell *matHeaderCellDef class="th-right"> SAVINGS </mat-header-cell>
        <mat-cell class="th-right" *matCellDef="let element" [ngClass]="{'negative': element.totSavings<0}">
            {{element.totSavings | currency:'USD': 'symbol' : '1.0-0'}} 
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="netCashFlow">
        <mat-header-cell *matHeaderCellDef class="th-right"> NET CASH FLOW </mat-header-cell>
        <mat-cell class="th-right" *matCellDef="let element" [ngClass]="{'negative': element.netCashFlow<0}">
            {{element.netCashFlow | currency:'USD': 'symbol' : '1.0-0'}} 
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="portInc">
        <mat-header-cell *matHeaderCellDef class="th-right">
            <div class="flex-row-container">
                <span class="ip-right-align" [ngClass]="isAdditionalColumns?'blue-text B':''">TAXABLE <br>PORTFOLIO INCOME</span>
                <!-- <mat-icon class="pointer B font30" aria-hidden="false" (click)="showAdditionalColumns()">{{isAdditionalColumns?'keyboard_arrow_left':'keyboard_arrow_right'}}</mat-icon> -->
                <!-- <mat-icon *ngIf="!isAdditionalColumns"  class="pointer B font30" matTooltipPosition ="below" matTooltipClass="tooltip" matTooltip="Expand" aria-hidden="false" (click)="showAdditionalColumns()">keyboard_arrow_right</mat-icon>
                <mat-icon *ngIf="isAdditionalColumns" class="pointer B font30 red-text" matTooltipPosition ="below" matTooltipClass="tooltip" matTooltip="Collapse" aria-hidden="false" (click)="showAdditionalColumns()">keyboard_arrow_left</mat-icon> -->
            </div>
        </mat-header-cell>
        <mat-cell class="th-right" *matCellDef="let element" [ngClass]="{'negative': element.portInc<0}">
            {{element.portInc | currency:'USD': 'symbol' : '1.0-0'}} 
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="c1Rmd">
        <mat-header-cell *matHeaderCellDef class="th-right">
            <div class="flex-row-container">
                <span class="ip-right-align" [ngClass]="isAdditionalColumns?'blue-text B':''">CLIENT <br> RMD</span>                
            </div>
        </mat-header-cell>
        <mat-cell class="th-right" *matCellDef="let element" [ngClass]="{'negative': element.c1Rmd<0}">
            {{element.c1Rmd | currency:'USD': 'symbol' : '1.0-0'}} 
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="c2Rmd">
        <mat-header-cell *matHeaderCellDef class="th-right">
            <div class="flex-row-container">
                <span class="ip-right-align" [ngClass]="isAdditionalColumns?'blue-text B':''">SPOUSE <br> RMD</span>                
            </div>
        </mat-header-cell>
        <mat-cell class="th-right" *matCellDef="let element" [ngClass]="{'negative': element.c2Rmd<0}">
            {{element.c2Rmd | currency:'USD': 'symbol' : '1.0-0'}}
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="totWithdrawal">
        <mat-header-cell *matHeaderCellDef class="th-right">
            <div class="flex-row-container">
                <span class="ip-right-align" [ngClass]="isAdditionalColumns?'blue-text B':''">PORTFOLIO <br> WITHDRAWAL</span>                
            </div>
        </mat-header-cell>
        <mat-cell class="th-right" *matCellDef="let element" [ngClass]="{'negative': element.totWithdrawal<0}">
            {{element.totWithdrawal | currency:'USD': 'symbol' : '1.0-0'}} 
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="rmdTaxes">
        <mat-header-cell *matHeaderCellDef class="th-right">
            <div class="flex-row-container">
                <span class="ip-right-align" [ngClass]="isAdditionalColumns?'blue-text B':''">RMD <br> TAXES</span>                
            </div>
        </mat-header-cell>
        <mat-cell class="th-right" *matCellDef="let element" [ngClass]="{'negative': element.rmdTaxes<0}">
            {{element.rmdTaxes | currency:'USD': 'symbol' : '1.0-0'}}
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="portTaxes">
        <mat-header-cell *matHeaderCellDef class="th-right"> <span class="ip-right-align blue-text B">PORTFOLIO <br> TAXES</span> </mat-header-cell>
        <mat-cell class="th-right" *matCellDef="let element" [ngClass]="{'negative': element.portTaxes<0}">
            {{element.portTaxes | currency:'USD': 'symbol' : '1.0-0'}}
        </mat-cell>
    </ng-container> 
    <ng-container matColumnDef="portEndBal">
        <mat-header-cell *matHeaderCellDef class="th-right"> <span class="ip-right-align blue-text B">MEDIAN PORTFOLIO <br> ENDING BALANCE</span>   </mat-header-cell>
        <mat-cell class="th-right" *matCellDef="let element" [ngClass]="{'negative': element.portEndBal<0}">
            {{element.portEndBal | currency:'USD': 'symbol' : '1.0-0'}} 
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="actions" [sticky]="true">
        <mat-header-cell class="th-right m-r5" style="border-right: 1px solid lightgray;" *matHeaderCellDef >
            <div class="m-r10">                
                <mat-icon *ngIf="!isAdditionalColumns" class="pointer font40 m-b10" matTooltipPosition ="below" matTooltipClass="tooltip" matTooltip="Expand" aria-hidden="false" (click)="showAdditionalColumns()">keyboard_arrow_right</mat-icon>
                <mat-icon *ngIf="isAdditionalColumns" class="pointer font40  m-b10" matTooltipPosition ="below" matTooltipClass="tooltip" matTooltip="Collapse" aria-hidden="false" (click)="showAdditionalColumns()">keyboard_arrow_left</mat-icon>
            </div>
        </mat-header-cell>        
        <mat-cell class="th-right" style="border-right: 1px solid lightgray;" *matCellDef="let element" >  
            <mat-icon *ngIf="pClRetAge && pClRetAge===element.c1Age"  class="pointer font20" matTooltipPosition ="below" matTooltipClass="tooltip" matTooltip="Client Retirement" [matMenuTriggerFor]="clientMenu" [matMenuTriggerData]="{clientid: pClId}">beach_access</mat-icon>
            <mat-icon *ngIf="sClRetAge && sClRetAge===element.c2Age"  class="pointer font20" matTooltipPosition ="below" matTooltipClass="tooltip" matTooltip="Spouse Retirement" [matMenuTriggerFor]="clientMenu" [matMenuTriggerData]="{clientid: sClId}">beach_access</mat-icon>          
        </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></mat-header-row>
    <mat-row mat-row *matRowDef="let row; columns: displayedColumns;">
    </mat-row>
</mat-table>
<mat-menu #clientMenu="matMenu" >
    <ng-template matMenuContent let-clientid="clientid">
        <gp-client-summary [ClientId]="clientid" [AllowToChange]="false"></gp-client-summary>
    </ng-template>
</mat-menu>

<!-- <mat-header-cell cdkDrag *matHeaderCellDef class="th-right"></mat-header-cell> -->